/* Contact form on /pages/troca: required fields and e-mail check, with the
   store's own error copy tied to each field. */
(function () {
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function readMessages(form) {
    var node = document.querySelector('[data-contact-messages="' + form.id + '"]');
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return {};
    }
  }

  function setError(field, message) {
    var control = field.querySelector('input, textarea');
    field.classList.toggle('is-invalid', Boolean(message));
    field.querySelector('[data-contact-error]').textContent = message || '';
    if (message) {
      control.setAttribute('aria-invalid', 'true');
    } else {
      control.removeAttribute('aria-invalid');
    }
    return message ? control : null;
  }

  function init(form) {
    var success = form.querySelector('[data-contact-success]');
    if (success) {
      success.scrollIntoView({ block: 'center' });
      success.focus({ preventScroll: true });
      return;
    }

    var messages = readMessages(form);
    var alert = form.querySelector('[data-contact-alert]');
    if (!alert.hidden) {
      alert.scrollIntoView({ block: 'center' });
    }

    form.addEventListener('submit', function (event) {
      var firstInvalid = null;
      alert.hidden = true;

      form.querySelectorAll('[data-contact-field]').forEach(function (field) {
        var control = field.querySelector('input, textarea');
        var value = control.value.trim();
        var message = '';
        if (!value) {
          message = messages.required;
        } else if (field.getAttribute('data-contact-field') === 'email' && !EMAIL_PATTERN.test(value)) {
          message = messages.email;
        }
        var invalid = setError(field, message);
        if (invalid && !firstInvalid) firstInvalid = invalid;
      });

      if (firstInvalid) {
        event.preventDefault();
        firstInvalid.focus();
      }
    });

    form.addEventListener('input', function (event) {
      var field = event.target.closest('[data-contact-field]');
      if (field && field.classList.contains('is-invalid')) {
        setError(field, '');
      }
    });
  }

  document.querySelectorAll('[data-contact-form]').forEach(init);
})();
